import { useEffect, useRef, useState } from 'react';

/** A paper slip that slides from the top for 3.2 s; swipe up or tap to dismiss. */
export function Toast({ text, sub, onDone }: { text: string; sub?: string; onDone: () => void }) {
  const [leaving, setLeaving] = useState(false);
  const startY = useRef<number | null>(null);
  useEffect(() => {
    const t = setTimeout(() => setLeaving(true), 3200);
    return () => clearTimeout(t);
  }, []);
  useEffect(() => {
    if (!leaving) return;
    const t = setTimeout(onDone, 260);
    return () => clearTimeout(t);
  }, [leaving, onDone]);
  return (
    <div
      className={`toast${leaving ? ' is-leaving' : ''}`}
      role="status"
      onClick={() => setLeaving(true)}
      onTouchStart={(e) => (startY.current = e.touches[0]?.clientY ?? null)}
      onTouchMove={(e) => {
        if (startY.current !== null && (e.touches[0]?.clientY ?? 0) - startY.current < -18) setLeaving(true);
      }}
    >
      <span className="toast__dot" aria-hidden="true" />
      <span className="toast__body">
        <b>{text}</b>
        {sub && <span>{sub}</span>}
      </span>
    </div>
  );
}
